import { render } from "./ProvaComponent.vue?vue&type=template&id=18067eee&scoped=true"
import script from "./ProvaComponent.vue?vue&type=script&lang=js"
export * from "./ProvaComponent.vue?vue&type=script&lang=js"

import "./ProvaComponent.vue?vue&type=style&index=0&id=18067eee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18067eee"]])

export default __exports__